import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const PolitiqueConfidentialite = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F6] py-24">
      <div className="max-w-4xl mx-auto px-6">
        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          variant="outline"
          className="mb-8 border-[#4A6B96] text-[#4A6B96] hover:bg-[#4A6B96] hover:text-white"
        >
          <ArrowLeft size={18} className="mr-2" />
          Retour à l'accueil
        </Button>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-12">
          <h1 className="text-4xl font-bold text-[#4A6B96] mb-8">Politique de Confidentialité</h1>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Collecte des données personnelles</h2>
              <p>
                Esprit Ouest collecte vos données personnelles uniquement dans le cadre de la gestion de votre demande de contact 
                ou de réservation. Les informations recueillies sont :
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Nom de l'entreprise (optionnel)</li>
                <li>Type d'espace recherché</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Utilisation des données</h2>
              <p>
                Vos données personnelles sont utilisées pour :
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2">
                <li>Répondre à vos demandes de renseignements</li>
                <li>Gérer vos réservations de visite</li>
                <li>Vous envoyer des informations sur nos services (avec votre consentement)</li>
                <li>Améliorer nos services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Conservation des données</h2>
              <p>
                Vos données sont conservées pendant la durée nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées, 
                conformément à la réglementation en vigueur (RGPD).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Vos droits</h2>
              <p className="mb-4">
                Conformément à la loi « Informatique et Libertés » et au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Droit d'accès à vos données personnelles</li>
                <li>Droit de rectification de vos données</li>
                <li>Droit à l'effacement de vos données</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit d'opposition au traitement</li>
                <li>Droit à la portabilité de vos données</li>
              </ul>
              <p className="mt-4">
                Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@esprit-ouest.fr" className="text-white font-bold hover:underline">contact@esprit-ouest.fr</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Sécurité</h2>
              <p>
                Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour assurer la sécurité 
                et la confidentialité de vos données personnelles.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#4A6B96] mb-4">Cookies</h2>
              <p>
                Notre site n'utilise pas de cookies de tracking. Seuls les cookies strictement nécessaires au fonctionnement du site sont utilisés.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
